import { Link as RouterLink, useNavigate } from "@tanstack/react-router";
import { useLocation } from "@tanstack/react-router";
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import { breadcrumbNameMap } from "../utils/breadcrumbs";

export default function BreadcrumbsNAV() {
  const location = useLocation();
  const navigate = useNavigate();
  const pathnames = location.pathname.split("/").filter((x) => x);

  if (pathnames.length === 0) return null;

  const crumbs = pathnames.map((value, index) => {
    const to = `/${pathnames.slice(0, index + 1).join("/")}`;
    return { to, label: breadcrumbNameMap[to] || value };
  });
  const parent = crumbs.length > 1 ? crumbs[crumbs.length - 2] : { to: "/" };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        px: 2,
        py: 0.75,
        minHeight: 36,
        borderBottom: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <IconButton
        size="small"
        onClick={() => navigate({ to: parent.to })}
        sx={{ mr: 0.5 }}
        aria-label="Go back"
      >
        <ArrowBackIcon fontSize="small" />
      </IconButton>
      <Breadcrumbs
        aria-label="breadcrumbs"
        separator={<NavigateNextIcon fontSize="small" />}
        sx={{ fontSize: "0.875rem" }}
      >
        <Link
          component={RouterLink}
          to="/"
          underline="hover"
          color="inherit"
          sx={{ fontSize: "0.875rem" }}
        >
          Home
        </Link>
        {crumbs.map((crumb, index) =>
          index === crumbs.length - 1 ? (
            <Typography
              key={crumb.to}
              sx={{
                color: "text.primary",
                fontSize: "0.875rem",
                fontWeight: 500,
              }}
            >
              {crumb.label}
            </Typography>
          ) : (
            <Link
              key={crumb.to}
              component={RouterLink}
              to={crumb.to}
              underline="hover"
              color="inherit"
              sx={{ fontSize: "0.875rem" }}
            >
              {crumb.label}
            </Link>
          ),
        )}
      </Breadcrumbs>
    </Box>
  );
}
